module.exports = __webpack_public_path__ + "static/img/incheon-investment.ba2d6f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/incheon-investment.jpg
// module id = KmfJ
// module chunks = 0